import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import b2b2b from '../assets/images/b2b2b-travel-portal-head.jpg';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const TourPackage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${b2b2b})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					TOUR PACKAGE SYSTEM
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					TOUR PACKAGE SYSTEM
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					Tour Package Website Development
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/tour-pkg-img.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								Arya Aviation is a focused Travel Portal Development company
								that offers a platform from where any customer, agent, or
								enterprise can do Flight Booking, Hotel Booking, Bus Booking,
								Car Booking System, and Holiday Package Booking. In the modern
								era, people prefer to do the process online, because all the
								data are displaying on a single platform.
							</p>
							<br />
							<p>
								Arya Aviation provides a Tour Package Management for the various
								types of Travel Portals like B2C, B2B, B2E, and B2B2B. In
								Holiday Package Management, the admin can add all the details
								like Package Category, Package Sub Category, Package Name,
								Inclusions, Exclusions, Itinerary, Tour Images, and many more.
								Admin can add the Day Wise Itinerary by filling the details of
								Day Itinerary, Itinerary Title and Itinerary Description. Admin
								also add the Short and Long Description of the Package to
								explain.
							</p>
							<br />
							<p>
								When all the details are added under the Tour Package
								Management, then the same details are displayed on Travel
								Websites like B2C, B2B, B2E, and B2B2B. Customer, agent or
								Enterprise can search the holidays with the help of Package
								Category. They can submit the query of a particular package and
								the same query is displayed in Query / Lead management System.
								They can send the query by providing the details like Passenger
								Name, Number of Travelers, Number of Days, Passenger Email ID,
								Passenger Contact Number, and many more.
							</p>
							<br />
							<p>
								Arya Aviation provides Customized Tour Package Websites. Admin
								adds Hotels (Hotel Name, Hotel Image, Hotel Amenities), Rooms
								(Room Name, Room Image, Room Amenities), Flights (Airline Name,
								Flight Number, Departure and Arrival Dates, Departure and
								Arrival Timings, Flight Fares and Fare Rules), Sightseeing
								(Name, Description, and Images), Tours Terms and Conditions,
								Tour Images, Tour Important Notes and cancellation Policies etc.
								All the tour related information like Hotel, Room, flight,
								activity, sightseeing and package details are display on the
								Websites and the same package can be booked through the Payment
								Gateway or the customer can send the query. Once booking gets
								successful, the customer or agent gets the Invoice related to
								the Package commercials. On the holiday detail page, customers
								can also download the complete package Itinerary for future
								reference in the pdf format, in which all the Hotels, Flight,
								Sightseeing, Terms and conditions, tour images, tour itinerary,
								cruise, and many more details are mentioned.
							</p>
							<br />
							<p>
								Tour Package vendor can add the Package Categories like
								International Package, Domestic Package, Seasonal Tours, One Day
								Picnic, and many more. On the basis of the Category List, the
								admin can add the Sub-Category List and then the package. Any
								customer can filter the Tour Package results according to their
								requirements. If customers changed their plan and wanted to book
								another tour, so they can select the Nearby Tours or Related
								Tours. From there they can send the tour package query or can
								book a tour through the Payment gateway.
							</p>
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default TourPackage;
